export default __webpack_public_path__ + "assets/images/c9841c5bf789cb3c9eca8f712ca6f068.svg";